<div class="gauge-container">
  <dx-circular-gauge [value]="score" [size]="{ width: 140, height: 80 }">
    <dxo-scale [startValue]="0" [endValue]="36" [tickInterval]="36">
      <dxo-label [customizeText]="customizeLabel"></dxo-label>
    </dxo-scale>

    <dxo-range-container>
      <dxi-range [startValue]="0" [endValue]="6" color="#e74c3c"></dxi-range>
      <dxi-range [startValue]="6" [endValue]="12" color="#e67e22"></dxi-range>
      <dxi-range [startValue]="12" [endValue]="18" color="#f1c40f"></dxi-range>
      <dxi-range [startValue]="18" [endValue]="27" color="#8bc34a"></dxi-range>
      <dxi-range [startValue]="27" [endValue]="36" color="#2ecc71"></dxi-range>
    </dxo-range-container>

    <dxo-value-indicator type="twoColorNeedle" color="#2c3e50"> </dxo-value-indicator>

    <dxo-geometry [startAngle]="180" [endAngle]="0"></dxo-geometry>
  </dx-circular-gauge>

  <div class="gauge-info">
    <p class="measure-name" [title]="measureName">{{ measureName }}</p>
    <p class="measure-score">{{ this.dataService.res('Ubt-Dashboard-Chart-Score') }} : {{ score }}</p>
    <p class="measure-details">
      {{ this.dataService.res('Ubt-Dashboard-Column-Speed') }}: {{ speed }} |
      {{ this.dataService.res('Ubt-Dashboard-Column-Benefit') }}: {{ benefit }}
    </p>
  </div>
</div>
